module.exports = __webpack_public_path__ + "img/error2000.94181dd8.jpg";